import React from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { connect } from 'react-redux'
import { handleExpiredAuthState } from '../../redux/actions/authActions'
import CandidatesApi from '../../api/CandidatesApi'
import { ApiException, ExpiredSessionException } from '../../api/exceptions'

const api = new CandidatesApi();

const EnrollEmailButton = ({ controlNumber, handleExpiredAuthState }) => {

  const MySwal = withReactContent(Swal)

  const handlerConfirm = async () => {

    MySwal.fire({
      toast: true,
      title:'Espere un momento...',
      position: 'top-end',
      showConfirmButton: false,
      onBeforeOpen: () => MySwal.showLoading()
    })

    await api.resendEnrollmentEmail(controlNumber)
    .then( response => {
      MySwal.fire({
        toast: true,
        icon: 'success',
        title:'¡El correo ha sido enviado exitosamente!',
        showConfirmButton: false,
        position: 'top-end',
        timer: 3000,
        timerProgressBar: true,
      })
    })
    .catch( error => {
      if (error instanceof ExpiredSessionException) {
        return handleExpiredAuthState();
      }

      MySwal.fire({
        toast: true,
        icon: 'error',
        title: (error instanceof ApiException) ? error.message : 'Hubo un error al procesar la solicitud. Intente más tarde.',
        position: 'top-end',
        timer: 3000,
        timerProgressBar: true,
      })
    })
  }

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Enviar Correo de Inscripción</strong>
        </Tooltip>
      }
    >
      <Button variant="success" onClick={handlerConfirm} >
        Reenviar correo{' '}<i className=" fa fa-mail-forward"></i>
      </Button>
    </OverlayTrigger>
  )
}

export default connect(null, {handleExpiredAuthState})(EnrollEmailButton)